import BlankTabIconWhite from '@assets/images/common/icon/blank-tab/blank-tab-white.svg';
import MenuDoClose from '@assets/images/common/icon/menu/menu-do-close.svg';
import MenuDoOpen from '@assets/images/common/icon/menu/menu-do-open.svg';
import { useTenantAuth } from '@src/context/auth/useTenantAuth';
import { SHARED_URL } from '@src/routes/shared';
import UserGuideLink from '@src/ui/elements/button/UserGuideLink';

import TenantAccountMenu from './TenantAccountMenu';

// import TenantNotification from './TenantNotification';

type NavBarProps = {
  hideSidebarToggleMenu?: boolean;
  isSidebarOpen?: boolean;
  toggleSidebar?: () => void;
};

const TenantNavBar = ({
  hideSidebarToggleMenu = false,
  isSidebarOpen,
  toggleSidebar,
}: NavBarProps) => {
  const { profile } = useTenantAuth();

  return (
    <>
      <header className='sticky top-0 z-[99999] flex h-[60px] w-full bg-primary-800'>
        {!hideSidebarToggleMenu && (
          <button
            type='button'
            className='grid w-[60px] place-items-center border-r border-solid border-r-white'
            onClick={toggleSidebar}
          >
            <img
              src={isSidebarOpen ? MenuDoClose : MenuDoOpen}
              alt={isSidebarOpen ? 'メニューを閉じる' : 'メニューを開く'}
              width='24'
              height='24'
            />
          </button>
        )}
        <div className='flex gap-2 text-[16px] text-white'>
          <p className='flex items-center border-b-2 border-solid border-b-white bg-primary-700 p-2 font-semibold'>
            ポータル管理
          </p>
          {profile?.tenant?.service?.online_community && (
            <a
              href={SHARED_URL.COMMUNITY_DEFAULT_CHANNEL}
              target='_blank'
              className='flex items-center gap-1 border-b-2 border-solid border-b-transparent p-2'
            >
              <span>オンラインコミュニティ</span>
              <img
                src={BlankTabIconWhite}
                alt=''
                width='16'
                height='16'
                className='size-4'
              />
            </a>
          )}
        </div>
        <div className='flex flex-1 items-center justify-end'>
          {/* in-app通知実装時に復活させる */}
          {/* <div className='flex size-[60px] items-center justify-center'>
            <TenantNotification />
          </div> */}
          <UserGuideLink
            userType='tenant'
            device='pc'
            color='white'
          />
          <div className='h-1/2 w-px bg-white'></div>
          <div className='w-full max-w-[270px] pl-5'>
            <TenantAccountMenu />
          </div>
        </div>
      </header>
    </>
  );
};

export default TenantNavBar;
